import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";

/**
 * Cartel mostrado en la vista de Funciones cuando el periodo supera los 7 días
 * y, por tanto, no se puede calcular la cobertura de las necesidades fraccionadas.
 *
 * Ofrece una acción para reducir el rango a los primeros 7 días del mes en curso.
 */
const FractionalNeedsLimitCard = ({ onSelectFirstWeek }) => {
	const { t } = useTranslation();

	return (
		<div className="fractional-needs-limit">
			<div className="fractional-needs-limit-icon">
				<FiCalendar />
			</div>
			<p className="fractional-needs-limit-title">
				{t("staffingLevels.fractionalLimit.title")}
			</p>
			<Button
				variant="primary"
				className="fractional-needs-limit-action"
				onClick={onSelectFirstWeek}
			>
				{t("staffingLevels.fractionalLimit.action")}
			</Button>
			<span className="fractional-needs-limit-hint">
				{t("staffingLevels.fractionalLimit.hint")}
			</span>
		</div>
	);
};

export default FractionalNeedsLimitCard;
